import { Component, Input, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { IUProperty } from "src/app/shared/interface/umbraco-property";
import { Subject } from "rxjs";

interface IDividerPanelComponentData {
  height: IUProperty<number>;
}

@Component({
  selector: "app-divider-panel",
  templateUrl: "./divider-panel.component.html",
  styleUrls: ["./divider-panel.component.less"],
})
export class DividerPanelComponent implements AfterViewInit {
  @Input() data: IDividerPanelComponentData;
  @ViewChild("panelEl", { static: false }) panelEl: ElementRef<HTMLElement>;

  private alive$ = new Subject();

  ngAfterViewInit(): void {
    this.setCustomHeight(this.data);
  }

  private setCustomHeight(d: IDividerPanelComponentData) {
    if (d.height && d.height.value && d.height.value > 0) {
      this.panelEl.nativeElement.style.height = `${d.height.value}px`;
    }
  }

  ngOnDestroy() {
    this.alive$.next();
    this.alive$.complete();
  }
}
